(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name finance.unicat.factory:Unicat
   *
   * @description
   *
   */
  angular
    .module('vcfinance.unicat')
    .factory('Unicat', Unicat);
  
  
  Unicat.$inject = ['restmod'];
  function Unicat(restmod) {
    return restmod.model('/routes/unicat').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/unicat/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            return this.$search({key: val});
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
